let $f4e2df6bd15f8569$var$_shadowDOM = false;
function $f4e2df6bd15f8569$export$98658e8c59125e6a() {
    return $f4e2df6bd15f8569$var$_shadowDOM;
}

export { $f4e2df6bd15f8569$export$98658e8c59125e6a as $ };
//# sourceMappingURL=import-BX771CwR.js.map
